module.exports = __webpack_public_path__ + "img/03.88e1dc38.gif";